import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { selectSharedDetails } from "../../../redux/selectors";
import "./ReloadErrorModal.scss";

// Blocking modal shown when the server can't be reached; the only way out is a reload
const ReloadErrorModal = () => {
  const { reloadModalOpen } = useSelector((state: RootState) => selectSharedDetails(state));

  return (
    <Modal
      show={reloadModalOpen}
      centered
      backdrop="static"
      keyboard={false}
      onHide={() => {}}
      className="reload-error-modal"
      backdropClassName="reload-error-backdrop"
      dialogClassName="reload-error-dialog"
    >
      <Modal.Body className="text-center p-4">
        {/* Inline SVG: an image request would fail while the network is down */}
        <svg className="reload-error-icon" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
          <circle cx="32" cy="32" r="32" fill="#f8d7da" />
          <path d="M24 24l16 16M40 24L24 40" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" />
        </svg>
        <h4 className="fs-20 fw-700 black-40 mt-3 mb-2">Something went wrong</h4>
        <p className="fs-16 fw-500 black-65 mb-4">
          We were unable to reach the server. Please reload the page and try again.
        </p>
        <Button
          className="w-100 py-2 fw-700"
          variant="secondary"
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ReloadErrorModal;
